<template>
  <div class="intro u-overlay">
    <div class="intro__logo u-relative u-w4of8">
      <img src="/images/logo--full.png" class="u-full-width">
    </div>
    <div class="intro__btn u-relative u-pad-x-md--sm u-w12of12--sm">
      <app-button :hasGradientBorder="true" @click="onCity">
        {{ $t('intro.continue') }}
      </app-button>
    </div>
  </div>
</template>

<script>
import { VirtualScroll } from '@/utils/VirtualScroll'
import gsap from 'gsap'
import { webGL } from '@/webGL/WebGL'

export default {
  name: 'Introduction',

  created () {
    this.$store.commit('global/introducted', true)

    this.virtualScroll = new VirtualScroll()
    this.virtualScroll.onNext(this.onCity)
  },

  beforeDestroy () {
    this.virtualScroll.onDestroy()
  },

  methods: {
    onCity () {
      this.$ga.send('Menu', 'Click', 'Scoll to continue')
      this.$router.push(this.$local('city'))
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/settings/variables'

.intro
  &__overlay
    opacity .7
  
  &__logo
    position absolute
    top 50%
    left 50%
    transform translateX(-50%) translateY(-50%)

  &__btn
    position absolute
    bottom $spacings.lg
    left 50%
    transform translateX(-50%)
</style>
